<template>
  <section>    
    <ProfileFunctionalityForm 
      v-if="profileId" 
      :profile-id="profileId"
      @added="fetchProfileFunctionalities"
    /> 

    <div class="mt-1 mb-1" />

    <v-data-table
      :headers="table.headers"
      :items="table.content"
      :items-per-page="5"
      :loading="table.isLoading"
      :options.sync="table.pagination"
      :server-items-length="table.total"
      :footer-props="{ 'items-per-page-options': [10, 20, 30, 40] }"
      class="elevation-0"      
    >
      <template v-slot:item.functionality.name="{ item }">
        <v-icon>admin_panel_settings</v-icon>        
        {{ item.functionality.name }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          color="red"
          @click="openDeleteModal(item)"
        >
          delete
        </v-icon>
      </template>
    </v-data-table>

    <ProfileFunctionalityDeleteModal
      v-if="deleteModal.isOpen"
      :item="deleteModal.item" 
      @close="deleteModal.isOpen = false"
      @deleted="fetchProfileFunctionalities"
    />
  </section>
</template>

<script>
  import PerfisService from '@/services/perfis.service';
  import ProfileFunctionalityDeleteModal from './ProfileFunctionalityDeleteModal.vue';
  import ProfileFunctionalityForm from './ProfileFunctionalityForm.vue';

  export default {
    name: 'ProfileFunctionalityList',

    components: {
      ProfileFunctionalityDeleteModal,
      ProfileFunctionalityForm
    },

    props: {
      profileId: {
        type: Number,
        required: true,
      },
    },
  
    data: () => ({
      table: {
        headers: [
          {
            text: 'Nome',
            align: 'start',
            sortable: false,
            value: 'functionality.name'
          },
          {
            text: 'Ações',
            align: 'start',
            sortable: false,
            value: 'actions',
            width: '100px'
          }
        ],
        content: [],
        total: 0,
        isLoading: false,
      },

      deleteModal: {
        isOpen: false,
        item: null,
      }
    }),

    watch: {
      'table.pagination': {
        handler() {
          this.fetchProfileFunctionalities()
        },
        deep: true
      },

      '$route.params.id'(newId, oldId) {      
        this.fetchProfileFunctionalities();
      }
    },

    methods: {    
      fetchProfileFunctionalities() {
        this.table.isLoading = true;
        PerfisService
          .listFunctionalities(this.profileId, this.buildParams())
          .subscribe(({items, totalItems }) => {
            this.table.content = items;
            this.table.total = totalItems;
            this.table.isLoading = false;
          }, () => {
            this.table.isLoading = false;
          });
      },

      buildParams() {
        const { page, itemsPerPage } = this.table.pagination;
        
        return {
          page,
          per_page: itemsPerPage,
          sort: 'created_at:desc'          
        };
      },

      openDeleteModal(item) {
        this.deleteModal.item = item;
        this.deleteModal.isOpen = true;
      },
    }
  }
</script>